import { render } from "./PreviewParent.vue?vue&type=template&id=0a5fa7ac"
import script from "./PreviewParent.vue?vue&type=script&lang=js"
export * from "./PreviewParent.vue?vue&type=script&lang=js"
script.render = render

export default script